import { GenitourinaryAssessmentHelpers } from "src/app/calvin-emr-shared/models/assessments/genitourinary.model";
import { GastrointestinalAssessmentHelpers } from "src/app/calvin-emr-shared/models/assessments/gastrointestinal.model";
import { IntakeOutputAssessmentHelpers } from "src/app/calvin-emr-shared/models/assessments/intake-output.model";
import { IntegumentaryAssessmentHelpers } from "src/app/calvin-emr-shared/models/assessments/integumentary.model";
import { MusculoskeletalAssessmentHelpers } from "src/app/calvin-emr-shared/models/assessments/musculoskeletal.model";
import { PainAssessmentHelpers } from "src/app/calvin-emr-shared/models/assessments/pain.model";
import { ProviderNotifiedAssessmentHelpers } from "src/app/calvin-emr-shared/models/assessments/provider-notified.model"
import { PsychosocialAssessmentHelpers } from "src/app/calvin-emr-shared/models/assessments/psychosocial.model";
import { NeurologicalAssessmentHelpers } from "src/app/calvin-emr-shared/models/assessments/neurological.model";
import { RespiratoryAssessmentHelpers } from "src/app/calvin-emr-shared/models/assessments/respiratory.model";
import { CardiovascularAssessmentHelpers } from "src/app/calvin-emr-shared/models/assessments/cardiovascular.model";
import { HEENTAssessmentHelpers } from "src/app/calvin-emr-shared/models/assessments/HEENT.model";
import { GeneralAppearanceAssessmentHelpers } from "src/app/calvin-emr-shared/models/assessments/general-appearance.model";

export const initialFormState = {
  // Date
  date: '',
  general: GeneralAppearanceAssessmentHelpers.initialState,
  heent: HEENTAssessmentHelpers.initialState,
  cardiovascular: CardiovascularAssessmentHelpers.initialState,
  respiratory: RespiratoryAssessmentHelpers.initialState,
  neurological: NeurologicalAssessmentHelpers.initialState,
  musculoskeletal: MusculoskeletalAssessmentHelpers.initialState,
  gastrointestinal: GastrointestinalAssessmentHelpers.initialState,
  genitourinary: GenitourinaryAssessmentHelpers.initialState,
  psychosocial: PsychosocialAssessmentHelpers.initialState,
  integumentary: IntegumentaryAssessmentHelpers.initialState,
  painAssessment: PainAssessmentHelpers.initialState,
  intakeOutput: IntakeOutputAssessmentHelpers.initialState,
  providerNotified: ProviderNotifiedAssessmentHelpers.initialState,
};